import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

import { firstValueFrom } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { User } from '../../models/User';
import { StorageService } from '../../services/storage.service';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from '../../services/translation.service';
import { PremiumOfferService } from '../../services/premium-offer.service';

@Component({
  selector: 'app-onboarding3',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './onboarding3.component.html',
  styleUrl: './onboarding3.component.scss',
})
export class Onboarding3Component {
  user?: User;
  selectedGraphism?: string;

  constructor(
    private router: Router,
    private toaster: ToastrService,
    private authService: AuthService,
    private storageService: StorageService,
    private translationService: TranslationService,
    private premiumOfferService: PremiumOfferService,
  ) {}

  async ngOnInit() {
    this.user = await firstValueFrom(this.authService.getUserInfoOrRefreshIfNeeded());
  }

  select(graphism: string) {
    this.selectedGraphism = graphism;
  }

  async next() {
    if (this.selectedGraphism === undefined) {
      return;
    }

    const actualUser = await firstValueFrom(this.authService.getUserInfoOrRefreshIfNeeded());
    const update = await firstValueFrom(this.authService.updateMyUser(actualUser.id ?? '', this.selectedGraphism, undefined, false));
    const newUser = await firstValueFrom(this.authService.forceUpdateUser());

    if (this.selectedGraphism === update.graphism) {
      if (this.shouldDisplayFourthStep()) {
        if (this.storageService.getMobile()) {
          if (this.storageService.isAnonymous()) {
            window.location.href = 'bedici://anosignup';
          } else {
            window.location.href = 'bedici://payment';
          }
        } else {
          this.router.navigate(['/onboarding/4']);
        }
      } else {
        this.router.navigate(['']);
      }

      this.toaster.success(this.translationService.instant('onboarding.3.successMessage'));
    }
  }

  shouldDisplayFourthStep(): boolean {
    return !this.storageService.isAnonymous() && this.premiumOfferService.canSeePremiumOffers(this.user);
  }
}
